import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { StorageManager } from "@/features/admin/components/storage-manager";
import { PageContainer } from "@/components/ui/page-container";

function AdminStoragePage() {
  return (
    <PageContainer maxWidth="5xl">
      <StorageManager />
    </PageContainer>
  );
}

export const adminStorageRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/storage",
  validateSearch: (search: Record<string, unknown>): { filter?: "orphaned" | "linked" } => ({
    filter: search.filter === "orphaned" || search.filter === "linked" ? search.filter : undefined,
  }),
  component: AdminStoragePage,
});
